import { RouteConfig } from 'react-router-config'
import AsyncComponent from './AsyncComponent'

const routes: RouteConfig[] = [
  {
    path: '/regulation',
    exact: true,
    component: AsyncComponent(() => import(/* webpackChunkName: 'regulation' */ '../@regulation')),
    hideSidebar: true,
    noBread: true,
  },
  {
    path: '/regulation/catalogue/:catalogueId/edit',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: 'regulation-catalogue-edit' */ '../@regulation/catalogue/edit')
    ),
    hideSidebar: true,
    noBread: true,
  },
  {
    path: '/regulation/catalogue/:catalogueId',
    exact: true,
    component: AsyncComponent(() =>
      import(
        /* webpackChunkName: 'regulation-catalogue-detail' */ '../@regulation/catalogue/detail'
      )
    ),
    hideSidebar: true,
    noBread: true,
  },
  {
    path: '/regulation/task/todo',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: 'regulation-task-todo' */ '../@regulation/task/todo')
    ),
    hideSidebar: true,
    noBread: true,
  },
  {
    path: '/regulation/task/done',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: 'regulation-task-done' */ '../@regulation/task/done')
    ),
    hideSidebar: true,
    noBread: true,
  },
  {
    path: '/regulation/setting/publish',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: 'regulation-setting-publish' */ '../@regulation/setting/publish')
    ),
    hideSidebar: true,
    noBread: true,
  },
  {
    path: '/regulation/detail',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: 'regulation-detail' */ '../@regulation/detail')
    ),
    hideSidebar: true,
    noBread: true,
  },
  {
    path: '/regulation/file',
    exact: true,
    component: AsyncComponent(() =>
      import(/* webpackChunkName: 'regulation-file' */ '../@regulation/file')
    ),
    hideSidebar: true,
    noBread: true,
  },
]

export default routes
